import { MapPin, Trophy } from "lucide-react";

import SurfaceCard from "@/components/primitives/SurfaceCard";
import { Badge } from "@/components/ui/badge";
import { SectionHead } from "@/components/organization/kit";

interface Ranking {
  position: string;
  category: string;
  location: string;
  source?: string;
}

interface MarketRankingsProps {
  rankings: Ranking[];
}

const MarketRankings = ({ rankings }: MarketRankingsProps) => {
  const positionStyle = (position: string) =>
    position.includes("#1") ? "bg-primary text-primary-foreground" : "bg-primary-tint text-primary-pressed";

  return (
    <SurfaceCard padding="lg" className="rounded-2xl">
      <SectionHead
        kicker="Market rankings"
        title="Industry standings"
        aside={<Trophy className="h-5 w-5 text-featured" strokeWidth={1.8} />}
      />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {rankings.map((ranking, index) => (
          <div
            key={index}
            className="flex items-center gap-4 rounded-[var(--radius-md)] border border-border bg-background p-4"
          >
            <div
              className={`flex h-14 w-14 items-center justify-center rounded-[var(--radius-md)] text-lg font-bold tabular-nums ${positionStyle(
                ranking.position,
              )}`}
            >
              {ranking.position}
            </div>
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-ink-900">{ranking.category}</p>
              <div className="mt-1 flex items-center gap-1.5">
                <MapPin className="h-3 w-3 text-ink-500" />
                <span className="text-sm text-ink-500">{ranking.location}</span>
              </div>
              {ranking.source && (
                <Badge variant="outline" className="mt-2 text-xs">
                  {ranking.source}
                </Badge>
              )}
            </div>
          </div>
        ))}
      </div>
    </SurfaceCard>
  );
};

export default MarketRankings;
